<template>
  <div>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
  </el-row>
    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

  <el-row v-if="!inEditingMode">
    <el-col :xs="8" :sm="8" :lg="8">
      <el-button v-if="from == ''" type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
        </el-button>
        <el-button v-if="from !='' && from != 'req_miles_statistic'" type="info" @click.prevent="goBackReport" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
        </el-button>
    </el-col>
    <el-col :xs="16" :sm="16" :lg="16" style="text-align: right">
      <el-button v-if="basicForm.status === 'draft'" type="warning" @click.prevent="handleDraft">暫存 <i
          class="el-icon-s-claim"></i></el-button>
      <el-button v-if="basicForm.status === 'draft' || basicForm.status === 'reject'" type="primary" @click.prevent="handleSign" class="mr-20">送簽核 <i
          class="el-icon-s-claim"></i></el-button>
    </el-col>
  </el-row>

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->

    <!--    基本資料-->
  <el-row v-if="!inEditingMode">  
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
            <el-button style="float: right; padding: 2px 0; margin-top: -12px" type="text"><el-tag type="success">{{basicForm.status | fmtSignResult }}</el-tag></el-button>
          </div>
          <div>
            <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="50px">
              <el-row>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>填單人: {{basicForm.userObj.username}} </p>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>報表日期: {{basicForm.startDate | fmtDate}}</p>
                </el-col>
              </el-row>
              
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <p class="mt-20">標題: {{basicForm.title}} </p>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>

    <!--    基本工作事項檢查-->
  <el-row v-if="!inEditingMode">  
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main >
        <el-card class="box-card mycard">
          <div slot="header" class="clearfix">
            <span>基本工作事項檢查</span>
          </div>
          <div>
            <el-form class="myform" label-position="top"　:model="basicForm"
                     :rules="visitRules"
                     ref="visitDataForm">
              <el-row class="ml-20">
                <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="" prop="checkList">


                    <el-checkbox-group v-model="checkList">
                      <el-checkbox style="display:block;" v-for="(opt,idx) in preCheckOption" :key="idx" :label="opt.value" :disabled="!canEdit"></el-checkbox>
                    </el-checkbox-group>

                   <!--  <el-tree
                        :data=""
                        show-checkbox
                        node-key="value"
                        ref="tree"
                        :props="props"
                        :default-checked-keys="precheckListOption">
                    </el-tree> -->
                  </el-form-item>

                </el-col>
              </el-row>
            </el-form>

          </div>
        </el-card>

        
        <el-card class="box-card mt-20">
          <div slot="header" class="clearfix">
            <span>出勤路線</span>
          </div>
          <div>
            <el-form class="myform" label-position="top"　:model="basicForm"
                     :rules="visitRules"
                     ref="visitDataForm">
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="" >
                    <el-tag 
                    :key="tag"
                    v-for="tag in dynamicTags"
                    :closable="canEdit"
                    :disable-transitions="false"
                    @close="handleClose(tag)">
                    {{tag}}
                  </el-tag>
                    <el-input
                      class="input-new-tag"
                      v-if="inputVisible"
                      v-model="inputValue"
                      ref="saveTagInput"
                      size="mini"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput" :disabled="!canEdit" >+ 路線</el-button>


                    <!-- <el-input type="textarea" rows="5" v-model="basicForm.visitRoute"></el-input> -->
                  </el-form-item>

                  <el-form-item label="服務間數" prop="visitCount">
                    <el-input-number v-model="basicForm.visitCount" :min="1" :max="30" :disabled="!canEdit" ></el-input-number>
                  </el-form-item>


                </el-col>
              </el-row>


            </el-form>

          </div>
        </el-card>


      </el-main>
    </el-col>
  </el-row>  


    <!-- ###################################################################################################### -->
    <!-- 工作項目資料 -->
    <!-- ###################################################################################################### -->
    

    <!--    客戶拜訪資料-->
 
  <el-row v-if="!inEditingMode">
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>客戶拜訪紀錄</span>
            <el-button id="add_item_btn" v-if="basicForm.status === 'draft'" style="float: right; padding: 5px 12px; margin-top: -7px;" 　type="primary"
                       @click.prevent="handleAdd" class="mr-20"><i class="el-icon-circle-plus-outline"></i> 新增 </el-button>
          </div>
          <div>
            <el-table :data="tableData" empty-text="無資料" stripe :default-expand-all="true">
              <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
              </el-table-column>
              <el-table-column label="客戶" prop="customer.company">
              </el-table-column>
              <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p class="mt-10 ml-10" v-if="scope.row.name !== null && scope.row.name !== ''">姓名: {{scope.row.name}}</p>
                  <p class="mt-20 ml-10">－服務內容－</p>
                  <p class="mt-10 ml-10" v-if="scope.row.deliveryContent !== null && scope.row.deliveryContent !== ''">送貨: {{scope.row.deliveryContent}}</p>
                  <p class="mt-10 ml-20" v-if="scope.row.deliveryAddress !== null && scope.row.deliveryAddress !== ''">指送地: {{scope.row.deliveryAddress}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.paymentReceive !== null && scope.row.paymentReceive !== ''">收款: {{scope.row.paymentReceive}}</p>
                  <p class="mt-10 ml-20" v-if="scope.row.paymentNote !== null && scope.row.paymentNote !== ''">{{scope.row.paymentNote}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.marketing !== null && scope.row.marketing !== ''">宣傳: {{scope.row.marketing}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.otherService !== null && scope.row.otherService !== ''">其它服務: {{scope.row.otherService}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.notes !== null && scope.row.notes !== ''">客戶回饋: {{scope.row.notes}}</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                    <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆附件嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="removeHistoryFile(f.id)">
                    <el-button v-if="canEdit" slot="reference" size="mini" type="danger"><i class="el-icon-error"></i> 刪除</el-button>
                  </el-popconfirm>

                  </li>
                </ol>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="120" v-if="canEdit">
                <template slot-scope="scope">
                  <el-button type="primary" circle @click="handleEdit(scope.row)"><i class="el-icon-edit"></i></el-button>

                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="deleteHistory(scope.row.id)"
                  >
                    <el-button type="danger" slot="reference" circle><i class="el-icon-delete"></i></el-button>

                  </el-popconfirm>
                </template>

              </el-table-column>


            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>

  <el-row v-if="!inEditingMode"> 
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="taskMain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>其他工作項目紀錄</span>
          </div>
          <div>
             <el-form class="myform" label-position="top"　:model="basicForm">
              <el-form-item label="" prop="taskContent" >
                <el-input ref="taskContent" type="textarea" rows="5" v-model="basicForm.taskContent" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>


  <!--    今日的交通工具與里程數計算 -->
  <el-row v-if="!inEditingMode"> 
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="taskMain">
        <el-card class="box-card">
          <div style="padding:20px">
            <div class="mb-20">今日哩程紀錄</div>
            <br/>
            <div v-if="canEdit">
              <el-radio v-model="basicForm.hasMile" label="N" @change="handleMileChange">無</el-radio>
              <el-radio v-model="basicForm.hasMile" label="Y" @change="handleMileChange">有</el-radio>  
            </div>
            <div v-else>
              <el-radio :disabled="true" v-model="basicForm.hasMile" label="N" @change="handleMileChange">無</el-radio>
              <el-radio :disabled="true" v-model="basicForm.hasMile" label="Y" @change="handleMileChange">有</el-radio>  
            </div>
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>
  <el-row v-if="!inEditingMode"> 
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main class="taskMain" v-if="basicForm.hasMile === 'Y'">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>交通工具與里程數</span>
            <el-button v-if="canEdit" type="primary" @click.prevent="handleAddDriving" class="card-header-btn mr-20" id="add_driving_btn">
                <i class="el-icon-circle-plus-outline"></i> 新增哩程紀錄
            </el-button>
          </div>
          <div>
            <el-table :data="drivingTableData" empty-text="無資料" stripe  :default-expand-all="true">
              <el-table-column label="項次" width="50">
                <template slot-scope="scope">{{scope.$index+1}}</template>
              </el-table-column>
              <el-table-column label="交通工具" prop="carType">
              </el-table-column>
              <el-table-column label="" type="expand" >
              <template slot-scope="scope">
                <p class="mt-10 ml-10">哩程: {{scope.row.startMile}}~{{scope.row.endMile}}</p>
                <ol class="ml-10">
                <li v-for="f in scope.row.fileListDisplay" :key="f.id" >
                  <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                  <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆附件嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="removeHistoryFile_driving(f.id)">
                    <el-button v-if="canEdit" slot="reference" size="mini" type="danger"><i class="el-icon-error"></i> 刪除</el-button>
                  </el-popconfirm>
                </li>
              </ol>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="120" v-if="basicForm.status === 'draft'">
                <template slot-scope="scope1">
                  <el-button type="primary" circle @click="handleEditCust_driving(scope1.row)"><i class="el-icon-edit"></i></el-button>

                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                     @confirm="handleDelete_driving(scope1.row.id)"
                  >
                    <el-button type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>

  <!-- 哩程 -->
  <el-row v-if="editDriving" class="editing-form">
    <el-form class="myform" label-position="top" :model="driving_form" ref="driving_form">
      <el-row>
        <el-col :xs="24" :sm="24" :md="12">
          <el-form-item label="汽車/機車" prop="carType">
            <el-select v-model="driving_form.carType" placeholder="請選擇" @change="handleDrivingChange()">
              <el-option label="汽車" value="汽車"></el-option>
              <el-option label="機車" value="機車"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :xs="24" :sm="24" :md="12">
          <el-form-item label="哩程數"></el-form-item>
        </el-col>
      </el-row>

      <el-row >
        <el-col :xs="24" :sm="24" :md="12" style="margin-top: -20px;">
          <el-form-item label="起" prop="startMile">
            <el-input-number v-model="driving_form.startMile" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12">
          <el-form-item label="迄" prop="endMile">
            <el-input-number v-model="driving_form.endMile" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-for="(btn, i) in btnCount" :key="i" class="upload-area">
        <el-col :xs="12" :sm="12" :md="12" class="pr-10">
          <el-form-item label="檔案備註">
            <el-input placeholder="檔案備註" v-model="driving_form.fileNotes[i]" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" >
          <el-form-item label="附件">
            <el-upload
                :multiple="false"
                class="upload-demo"
                action="/api/file/upload"
                :on-success="handleUploadSuccess_driving"
                :before-upload="beforeUpload"
                :on-remove="handleFileRemove_driving">
              <el-button size="small" type="primary">上傳文件</el-button>
              <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="mb-20 mt-20">
        <el-col :xs="24" :sm="24" :md="24">
          <el-button size="small" type="primary" @click="newUploadField_driving()">新增上傳</el-button>
        </el-col>
      </el-row>
    </el-form>
    
    <div class="mt-20 mb-20 fr">
      <el-button @click="cancelAddDriving">取 消</el-button>
      <el-button type="primary" @click="saveDriving('driving_form')">確 定</el-button>
    </div>

  </el-row>

  <!--    簽核紀錄-->
  <el-row v-if="!inEditingMode">
    <el-col :xs="24" :sm="24" :lg="24" v-if="basicForm.status !== 'draft'" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>
            <el-table :data="historyTableData" empty-text="無資料" stripe :default-expand-all="true">
              <el-table-column label="時間" prop="updatedAt" width="170">
                <template slot-scope="scope">
                  <p>簽核時間 :</p>
                  <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                  <p class="mt-10">{{ scope.row.signerObj.username }}</p>
                </template>
              </el-table-column>
              <el-table-column label="結果" prop="signResult">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.signResult === 'N'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                  <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                </template>
              </el-table-column>
              

              <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p>簽核備註 : {{ scope.row.notes }}</p>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>

    
  <el-row v-if="editMode" style="background-color: white; padding:20px">
    <div id="create_item_div" v-if="actionType === 'create'">
      <el-form id="item_create_form" class="myform" label-position="top" :model="form" ref="visitForm"  :rules="visitFormRules">
        <el-row width="100%">
          <el-col :xs="24" :sm="24" :md="12" 　width="100%">
            <el-form-item label="客戶公司名" prop="company" >
              <el-input placeholder="請輸入客戶公司名" v-model="form.company"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="抵達時間" prop="arrivalTime">
              <el-time-picker
                  v-model="form.arrivalTime"
                  selectableRange="['08:00' - '20:00']"
                  placeholder="選擇時間"
                  format='HH:mm'
                  value-format="HH:mm">
              </el-time-picker>
            </el-form-item>
          </el-col> -->
        </el-row>

       
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="服務內容">
            </el-form-item>
            <el-form-item prop="deliveryChecked"  style="margin-top: -30px;">
              <el-checkbox v-model="form.deliveryChecked" @change="handleDeliveryItem">送貨</el-checkbox>
            </el-form-item>
            <div v-if="form.deliveryChecked">
              <el-form-item label="" prop="deliveryContentChecked" style="margin-top: -20px; margin-left: 20px;">
                <el-checkbox-group v-model="form.deliveryContentChecked" @change="handleDeliveryChange">
                  <el-checkbox v-for="(opt,idx) in deliveryContentOptions" :key="idx" :label="opt"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item  v-if="shippingToDifferentAddress === true" prop="deliveryAddress" class="ml-20">
                <el-input autocomplete="off" v-model="form.deliveryAddress" placeholder="請輸入指送地址"></el-input>
              </el-form-item>
            </div>
            
          </el-col>
        </el-row>


        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item prop="paymentChecked">
              <el-checkbox v-model="form.paymentChecked" @change="handlePaymentItem">收款</el-checkbox>
            </el-form-item>
            <div v-if="form.paymentChecked" style="margin-top: -20px; margin-left: 20px;">
              <el-form-item >
                <el-checkbox-group v-model="form.paymentReceiveChecked" @change="changeEffect">
                  <el-checkbox v-for="opt in paymentReceiveOptions" :key="opt" :label="opt"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="paymentNote">
                <el-input autocomplete="off"　placeholder="收款備註" v-model="form.paymentNote"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item prop="marketingChecked">
              <el-checkbox v-model="form.marketingChecked" @change="handleMarketingItem">宣傳</el-checkbox>
            </el-form-item>
            <el-form-item v-if="form.marketingChecked" prop="marketing" class="ml-20">
               <el-input placeholder="請輸入宣傳內容" v-model="form.marketing"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="其它服務" prop="otherService">
               <el-input placeholder="請輸入其它服務內容" v-model="form.otherService"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row class="mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="客戶交流與客戶回饋紀錄" prop="notes">
              <el-input type="textarea" v-model="form.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row v-for="(btn, i) in btnCount" :key="i" class="upload-area">
          <el-col :xs="12" :sm="12" :md="12" class="pr-10">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" >
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20 mt-10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField()">新增上傳</el-button>
          </el-col>
        </el-row>

      </el-form>

      <div  style="float: right;" class="mt-20">
        <el-button @click="cancelAdd">取 消</el-button>
        <el-button type="primary" @click="saveCustomerVisit('visitForm')">確 定</el-button>
      </div>
    </div>



    <!--------------------------------------------------------------------------------------------------->
  <!--------------------------------------------------------------------------------------------------->
    <!-- Update Form -->
    <!--------------------------------------------------------------------------------------------------->

    <div id="update_item_div" v-if="actionType === 'update'">
      <el-form id="item_update_form" class="myform" label-position="top" 
          :model="updateForm" ref="visitForm_update" :rules="updateVisitFormRules">

        <el-row width="100%">
          <el-col :xs="24" :sm="24" :md="12" 　width="100%">
            <el-form-item label="客戶公司名" prop="company" >
              <el-input placeholder="請輸入客戶公司名" v-model="updateForm.company"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="服務內容">
            </el-form-item>
            <el-form-item prop="deliveryChecked"  style="margin-top: -30px;">
              <el-checkbox v-model="updateForm.deliveryChecked" @change="handleDeliveryItem_update">送貨</el-checkbox>
            </el-form-item>

            <div v-if="updateForm.deliveryChecked">
              <el-form-item label="" prop="deliveryContentChecked" style="margin-top: -20px; margin-left: 20px;">
                <el-checkbox-group v-model="updateForm.deliveryContentChecked" @change="handleDeliveryChange">
                  <el-checkbox v-for="(opt,idx) in deliveryContentOptions" :key="idx" :label="opt"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item  v-if="shippingToDifferentAddress === true" prop="deliveryAddress" class="ml-20">
                <el-input autocomplete="off" v-model="updateForm.deliveryAddress" placeholder="請輸入指送地址"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item prop="paymentChecked">
              <el-checkbox v-model="updateForm.paymentChecked" @change="handlePaymentItem_update">收款</el-checkbox>
            </el-form-item>
            <div v-if="updateForm.paymentChecked" style="margin-top: -20px; margin-left: 20px;">
              <el-form-item >
                <el-checkbox-group v-model="updateForm.paymentReceiveChecked" @change="changeEffect">
                  <el-checkbox v-for="opt in paymentReceiveOptions" :key="opt" :label="opt"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="paymentNote">
                <el-input autocomplete="off"　placeholder="收款備註" v-model="updateForm.paymentNote"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>


        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item prop="marketingChecked">
              <el-checkbox v-model="updateForm.marketingChecked" @change="handleMarketingItem_update">宣傳</el-checkbox>
            </el-form-item>
            <el-form-item v-if="updateForm.marketingChecked" prop="marketing" class="ml-20">
               <el-input placeholder="請輸入宣傳內容" v-model="updateForm.marketing"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="其它服務" prop="otherService">
               <el-input placeholder="請輸入服務內容" v-model="updateForm.otherService"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row class="mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="客戶交流與客戶回饋紀錄" prop="notes">
              <el-input type="textarea" v-model="updateForm.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row v-for="(btn, i) in updateBtnCount" :key="i" class="upload-area">
          <el-col :xs="12" :sm="12" :md="12" class="pr-10">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="updateForm.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" >
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess_update"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove_update">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20 mt-10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField_update()">新增上傳</el-button>
          </el-col>
        </el-row>

       
      </el-form>

      <div  style="float: right;" class="mt-20">
        <el-button @click="cancelEdit">取 消</el-button>
        <el-button type="primary" @click="saveCustomerVisit_update('visitForm_update')">確 定</el-button>
      </div>
    </div>
  </el-row>

  <!-- 附件圖-->
  <el-row>
    <el-dialog title="附件圖"
               :visible.sync="img.dialog"
               :width="dw">
        <div class="demo-image">
          <el-image
            style="width: 100%; max-width: 100%; height: 100%;"
            :src="img.url"
            fit="cover" lazy>
              
            <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
            </el-image>
        </div>
     </el-dialog>
  </el-row>

</div>

</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";

export default {
  name: "TodoDetailDriver",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let treeCheck = (rule, value, callback) => {
      let selectedIds = this.$refs.tree.getCheckedKeys();

      if (!selectedIds || selectedIds.length === 0) {
        callback(new Error('請確認出勤前工作'))
      } else {
        callback()
      }
    }

    return {
      from: '',
      editMode: false,
      drawer: false,
      editDriving: false,
      direction: 'ltr',

      actionType: '',

      img:{
        dialog: false,
        url:''
      },
      checkList:[],

      props: {
        label: 'name'
      },
      historyTableData: [],
      precheckListOption: [],
      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        status:'',
        endDate: '',
        preCheckItem: '',
        preCheckTree:[],
        visitRoute: '',
        visitCount: 0,
        hasMile:'N'
      },
      visitForm: {
        customerId: '',
        arrivalTime: '',
        deliveryContent: [],
        serviceContent: [],
        paymentReceive: [],
        notes: '',
        fileList: []
      },

      drivingTableData:[],
      driving_form: {
        mytodoId: '',
        carType:'',
        startMile:0,
        endMile:0,
        fileList: [],
        fileNotes: []
      },

      inputValue:'',
      inputVisible:false,
      dynamicTags:[],

      loading: false,
      dw: '50%',
      fileList: [],
      
      precheckList: [],
      tableData: [],
      options: [],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      deliveryContentOptions: ['送店', '指送'],
      shippingToDifferentAddress: false,
      serviceContentOptions: ['補目錄', '做宣傳', '交流','收退料', '放帳單'],
      paymentReceiveOptions: ['退%','扣尾數','現金', '期票'],
      btnCount: 0,
      updateBtnCount: 0,
      form: {
        id:'',
        mytodoId: '',
        custId: '',
        arrivalTime: '',
        
        deliveryChecked:false,
        paymentChecked:false,
        marketingChecked: false,

        paymentNote:'',

        deliveryContentChecked: [],
        deliveryContent: '',
        paymentReceiveChecked: [],
        paymentReceive: '',

        notes: '',
        fileList: [],
        fileNotes: [],
        discountType:'',
        marketing:'',
        otherService:'',
        name:'',
        company:'',
        hidden_qty:0
      },
      preCheckOption: [],

      updateForm: {
        id:'',
        mytodoId: '',
        name:'',
        company:'',
        deliveryContentChecked: [],
        deliveryContent: '',
        deliveryAddress: '',
        paymentReceiveChecked: [],
        paymentReceive: '',
        marketing:'',
        otherService:'',
        notes: '',
        fileList: [],
        fileNotes: [],

        deliveryChecked:false,
        paymentChecked:false,
        marketingChecked: false,

        paymentNote:''
      },
      

      deliveryCheckFlag:[],
      paymentCheckFlag:[],


      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}]
      },
      visitRules: {
        preCheckTree:[{validator: treeCheck, trigger: 'change'}],
        visitRoute: [{validator: checkName, trigger: 'change'}]
      },
      visitFormRules: {
        company: [{required: true, validator: checkName, trigger: 'change'}],
        // arrivalTime: [{required: true, validator: checkName, trigger: 'change'}],
        // customerRecord: [{required: true, validator: checkName, trigger: 'blur'}]
      },
      updateVisitFormRules: {
        company: [{required: true, validator: checkName, trigger: 'change'}],
      }

    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    canEdit() {
      return this.basicForm.status === 'draft' || this.basicForm.status === 'reject'
    },
    inEditingMode(){
      return this.editMode || this.editDriving
    }
  },
  methods: {
    showImage(uuid) {
      console.log('showImage')
      this.img.url = this.displayAvatar(uuid)
      this.img.dialog = true
    },
    removeHistoryFile(id) {
      this.request.delete("/todo/customer/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.loadCustomerHistoryData()
          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
    deleteHistory(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    handleDeliveryItem(){
      //console.log('form.deliveryChecked:', this.form.deliveryChecked)
      if (!this.form.deliveryChecked) {
        //clear sub item
        this.form.deliveryContentChecked = []
        this.form.deliveryAddress = ''
        this.shippingToDifferentAddress = false

      }
    },
    handleDeliveryItem_update(){
      if (!this.updateForm.deliveryChecked) {
        this.updateForm.deliveryContentChecked = []
        this.updateForm.deliveryAddress = ''
        this.shippingToDifferentAddress = false
      }
    },
    

    handlePaymentItem(){
      if (!this.form.paymentChecked) {
        //clear sub item
        this.form.paymentReceiveChecked = []
        this.form.paymentNote = ''
      }
    },
    handleMarketingItem(){
      if (!this.form.marketingChecked) {
        this.form.marketing = ''
      }
    },

    handlePaymentItem_update(){
      if (!this.updateForm.paymentChecked) {
        //clear sub item
        this.updateForm.paymentReceiveChecked = []
        this.updateForm.paymentNote = ''
      }
    },
    handleMarketingItem_update(){
      if (!this.updateForm.marketingChecked) {
        this.updateForm.marketing = ''
      }
    },

    //參數為勾選的值，array
    handleDeliveryChange(selectedItem){
      if (selectedItem.includes('指送')) {
        this.shippingToDifferentAddress = true
      } else {
        this.shippingToDifferentAddress = false
      }
      //this.changeEffect()
    },



    handleSelect(item) {
      this.form.custId = item.id
    },
    querySearch(str, cb){
      this.request.get("/customer/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.company + "(" + item.name + ")",
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
    showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    loadCustomerHistoryData() {
      this.request.get("/todo/customer/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '客戶拜訪紀錄撈取失敗')
        }
      })
    },
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('todo/saveMytodo', this.form)

            this.showResult('success', '資料更新成功.')

            await this.loadCustomerHistoryData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleDraft() {
      //let selectedIds = this.$refs.tree.getCheckedKeys();
      this.basicForm.preCheckItem = this.checkList.join(",")
      this.basicForm.visitRoute = this.dynamicTags.join(",");
      this.handleSubmitForm()
    },
    handleSign() {
      this.$refs['visitDataForm'].validate(async valid => {
        
        if (valid) {
          this.$confirm('資料填寫已完成，按下「確定」後將呈主管簽核?', '提醒', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            //let selectedIds = this.$refs.tree.getCheckedKeys();

            this.basicForm.preCheckItem = this.checkList.join(",")
            this.basicForm.visitRoute = this.dynamicTags.join(",");
            console.log(this.basicForm)
            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.showResult('success', '表單送簽核成功')
                 this.$nextTick(()=>{
                    this.goBack()
                 })
               
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
        }
      })
    },
    handleAdd() {
      this.editMode = true
      this.actionType = "create"
      
      this.form.id = null
     
      

      this.$nextTick(()=>{
        this.btnCount = 0
         this.form.fileList = []
         this.form.fileNotes = []
        document.getElementById("item_create_form").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    handleEdit(rowData) {
      console.log(rowData)
      this.actionType = "update"
      this.editMode = true
      
      this.updateBtnCount = 0

      this.$nextTick(() => { 
        this.updateForm.id = rowData.id
        this.updateForm.mytodoId = rowData.mytodoId
        this.updateForm.company = rowData.company

        //處理送貨
        this.updateForm.deliveryContent = rowData.deliveryContent
        if (rowData.deliveryContent !== '') { //有送貨資訊
          this.updateForm.deliveryChecked = true
          if(rowData.deliveryContent.indexOf(",") !== -1) {
            this.updateForm.deliveryContentChecked = rowData.deliveryContent.split(',')  
          } else {
            this.updateForm.deliveryContentChecked.push(rowData.deliveryContent)
          }
          if (rowData.deliveryContent.indexOf('指送') !== -1) {
            this.updateForm.deliveryAddress = rowData.deliveryAddress
            this.shippingToDifferentAddress = true
          } else {
            this.shippingToDifferentAddress = false
          }
        } else {
          this.updateForm.deliveryChecked = false
        }

        //處理收款
        this.updateForm.paymentReceive = rowData.paymentReceive
        if (rowData.paymentReceive !== ''){ //有收款資訊
          this.updateForm.paymentChecked = true

          if(rowData.paymentReceive.indexOf(",") !== -1) {
            this.updateForm.paymentReceiveChecked = rowData.paymentReceive.split(',')  
          } else {
            this.updateForm.paymentReceiveChecked.push(rowData.paymentReceive)
          }

          this.updateForm.paymentNote = rowData.paymentNote

        } else {
          this.updateForm.paymentChecked = false
        }

        //處理宣傳
        this.updateForm.marketing = rowData.marketing
        if (rowData.marketing !== ''){ //有收款資訊
          this.updateForm.marketingChecked = true
        } else {
          this.updateForm.marketingChecked = false
        }

        //其它服務
        this.updateForm.otherService = rowData.otherService

        //客戶回饋
        this.updateForm.notes = rowData.notes

        
        this.updateForm.fileList =  []
        this.updateForm.fileNotes = []

      });

      //this.actionType = 'update'

      // this.form.name = rowData.name
      // this.form.company = rowData.company

      // this.btnCount = 0
      // //this.updateForm = rowData //don't do this!!!
      // this.form.id = rowData.id
      // this.form.userId = rowData.userId
      // this.form.mytodoId = rowData.mytodoId
      // this.form.deliveryContentChecked = rowData.deliveryContent.split(",")
      // this.form.serviceContentChecked = rowData.serviceContent.split(",")
      // this.form.paymentReceiveChecked = rowData.paymentReceive.split(",")
      // this.form.notes = rowData.notes
        
      // this.form.fileList = []
      // this.form.fileNotes = []
      // if (rowData.deliveryContent.indexOf('指送') !== -1) {
      //   this.form.deliveryAddress = rowData.deliveryAddress
      //   this.shippingToDifferentAddress = true
      // } else {
      //   this.shippingToDifferentAddress = false
      // }


    },
    handleDelete(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    closeDialog() {
      this.form.notes = ''
      this.$refs['visitForm'].resetFields()
      //this.loadCustomerHistoryData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "50%"
      }
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data

          if (res.data.preCheckItem !== '') {
            this.checkList = res.data.preCheckItem.split(",")
          }
          // console.log("this.basicForm.visitRoute:", this.basicForm.visitRoute)
          if (this.basicForm.visitRoute !== '') {
            this.dynamicTags = this.basicForm.visitRoute.split(",")
          }
          
          this.loadCustomerHistoryData_driving()


        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      this.form.todoType = this.getTodoType()
    },
    getTodoType() {
      this.userInfo.id;
    },
    loadPreCheckItem() {
      let req = '/dic/type?queryField=pre_check'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.preCheckOption = res.data
        }
      })
    },
    goBack() {
      this.$router.push('/daily/todo')
    },
    goBackReport() {
      this.$router.push('/report/delivery-statistic')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleUploadSuccess_update(res, file) {
      this.updateForm.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    handleFileRemove_update(file, fileList) {
      this.updateForm.fileList = this.updateForm.fileList.filter(e => e !== file.response.uuid)
    },
    newUploadField() {
      this.btnCount++
    },
     newUploadField_update() {
      this.updateBtnCount++
    },
    saveCustomerVisit(formName) {
      this.$refs[formName].validate(async valid => {
        
        if (valid) {
          try {
            
            //將陣列轉換成後台可以接的字串
            if (this.form.deliveryContentChecked.length > 1) {
              this.form.deliveryContent = this.form.deliveryContentChecked.join(",")  
            }else {
              if (this.form.deliveryContentChecked.length ==0) {
                this.form.deliveryContent = ''
              }else{
                this.form.deliveryContent = this.form.deliveryContentChecked[0]
              }
            }

            if (this.form.paymentReceive.length > 1) {
              this.form.paymentReceive = this.form.paymentReceiveChecked.join(",")  
            }else {
              if (this.form.paymentReceiveChecked.length ==0) {
                this.form.paymentReceive = ''
              }else{
                this.form.paymentReceive = this.form.paymentReceiveChecked[0]
              }
            }
           
            this.doSave(this.form)

          } catch (e) {
            console.log(e.stack)
            this.showResult('error', e.stack)
          }
        }
      })

    },
    saveCustomerVisit_update(formName) {
      this.$refs[formName].validate(async valid => {
        
        if (valid) {
          try {
            
            //將陣列轉換成後台可以接的字串
            if (this.updateForm.deliveryContentChecked.length > 1) {
              this.updateForm.deliveryContent = this.updateForm.deliveryContentChecked.join(",")  
            }else {
              if (this.updateForm.deliveryContentChecked.length ==0) {
                this.updateForm.deliveryContent = ''
              }else{
                this.updateForm.deliveryContent = this.updateForm.deliveryContentChecked[0]
              }
            }

            if (this.updateForm.paymentReceive.length > 1) {
              this.updateForm.paymentReceive = this.updateForm.paymentReceiveChecked.join(",")  
            }else {
              if (this.updateForm.paymentReceiveChecked.length ==0) {
                this.updateForm.paymentReceive = ''
              }else{
                this.updateForm.paymentReceive = this.updateForm.paymentReceiveChecked[0]
              }
            }

            

            console.log('save updateForm:', this.updateForm)

            this.doSave(this.updateForm)

          } catch (e) {
            console.log(e.stack)
            this.showResult('error', e.stack)
          }
        }
      })

    },

    clearInputForm() {
      this.$refs['visitForm'].resetFields()
      console.log('clear...')
    },

    cancelEdit(){
      this.deliveryCheckFlag = []
      this.paymentCheckFlag = []
      this.$refs['visitForm_update'].resetFields()
      this.editMode = false
    },
    cancelAdd() {
      this.clearInputForm()


      this.editMode = false
      this.$nextTick(()=>{
        document.getElementById("add_item_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })



      // this.form.notes = ''
      // this.form.custLabel = ''
      // this.$refs['visitForm'].resetFields()

      // this.actionType = ''
      // this.btnCount = 0
      
      
      // this.editMode = false
      // this.$nextTick(()=>{
      //   document.getElementById("add_item_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      // })
    },

    changeEffect(item) {
      // this.form.hidden_qty = this.form.hidden_qty + 1
      // this.form.hidden_qty = this.form.hidden_qty - 1
    },

    // for update
    handleUpdateDeliveryChange(selectedItem){
      if (selectedItem.includes('指送')) {
        this.shippingToDifferentAddress = true
      } else {
        this.shippingToDifferentAddress = false
      }
    },
    handleUpdateUploadSuccess(res, file) {
      this.updateForm.fileList.push(res.uuid)
    },
    handleUpdateFileRemove(file, fileList) {
      this.updateForm.fileList = this.updateForm.fileList.filter(e => e !== file.response.uuid)
    },
    newUpdateUploadField() {
      console.log('newUpdateUploadField:', this.updateBtnCount)
      this.updateBtnCount++
    },
    cancelUpdate(){
      console.log('cancelUpdate')
      this.updateForm.notes = ''
      this.updateForm.custLabel = ''
      //this.$refs['updateVisitForm'].resetFields()

      this.actionType = ''
      this.updateBtnCount = 0
      
      
      this.editMode = false
      this.$nextTick(()=>{
        document.getElementById("add_item_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    
    saveUpdateCustomerVisit(formName){

      this.$refs[formName].validate( valid => {
        console.log(valid)
        if (valid) {
          try {
            
            //將陣列轉換成後台可以接的字串
            this.updateForm.deliveryContent = this.updateForm.deliveryContentChecked.join(",")
            this.updateForm.paymentReceive = this.updateForm.paymentReceiveChecked.join(",")

           
            this.doSave(this.updateForm)

          } catch (e) {
            console.log(e.stack)
            this.showResult('error', e.stack)
          }
        }
      })
    },


    doSave(form) {

        console.log("doSave:", form);
        
        this.request.post("/todo/customer/history", form).then(res => {

          if (res.code === '200') {
            if (this.actionType === 'create') {
              //this.$refs['visitForm'].resetFields()  
            } else {
              //this.$refs['visitForm_update'].resetFields()
            }
            
            this.editMode = false
            this.loadCustomerHistoryData()
            this.showResult('success', '資料更新成功')

             this.$nextTick(()=>{
                document.getElementById("add_item_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
              })

          } else {
              console.log('errrrrrrrrrrrrrrrrr');
            this.showResult('error', res.message)

          }
        })
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    loadMyCustomer() {
      this.request.get("/customer/query1?keyword=&all=y").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無負責的客戶名稱']
        }
      })
    },
    handleDrivingChange(){
      console.log(this.driving_form.carType)
    },
    newUploadField_driving() {
      this.btnCount++
    },
    cancelAddDriving(){
      this.editDriving = false
    },
    saveDriving(formName){
      console.log(this.driving_form)

      this.$refs[formName].validate(async valid => {
        
        if (valid) {
          try {
            this.request.post("/todo/driving/history", this.driving_form).then(res => {
              if (res.code === '200') {
                this.editDriving = false
                this.loadCustomerHistoryData_driving()

                this.$nextTick(()=>{
                  this.showResult('success', '新增成功')
                  document.getElementById("add_driving_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
              } else {
                this.showResult('error', res.message)
              }
            })
          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })

    },
    handleUploadSuccess_driving(res, file) {
      this.driving_form.fileList.push(res.uuid)
    },
    handleFileRemove_driving(file, fileList) {
      this.driving_form.fileList = this.driving_form.fileList.filter(e => e !== file.response.uuid)
    },
    handleMileChange(){
      console.log(this.basicForm.hasMile)
    },
    handleAddDriving(){
      this.editDriving = true
      this.driving_form.id = null
      this.driving_form.fileList = []
      this.driving_form.fileNotes = []
      this.btnCount = 0
    },
    handleEditCust_driving(rowData) {
      this.editDriving = true
      this.driving_form = rowData
      this.driving_form.fileList = []
      this.driving_form.fileNotes = []
      this.driving_form.fileListDisplay = []
      this.btnCount = 0
    },
    handleDelete_driving(id) {
      this.request.delete("/todo/driving/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData_driving()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    loadCustomerHistoryData_driving() {
      this.request.get("/todo/driving/history/" + this.driving_form.mytodoId).then(res => {
        if (res.code === '200') {
          this.drivingTableData = res.data
          console.log('res.data.length:', res.data.length)
          if (res.data.length > 0) {
            this.basicForm.hasMile = 'Y'
          } else {
            this.basicForm.hasMile = 'N'
          }
        } else {
          this.showResult('error', '哩程紀錄撈取失敗')
        }
      })
    },
    removeHistoryFile_driving(id) {
      console.log('removeHistoryFile_driving')
      this.request.delete("/todo/driving/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.loadCustomerHistoryData_driving()
          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId
    this.driving_form.mytodoId = this.$route.params.mytodoId

    let from = this.$route.query.from
    if (typeof from === 'undefined') {
      this.from = ''
    } else {
      this.from = from
    }
    
    //
    this.loadCustomerHistoryData()

    

    this.loadJobSignHistory()

    //設定一些欄位預設值
    this.formDefault()

    //出勤前檢查工作選項
    this.loadPreCheckItem()

    //撈我負責的客戶
    //this.loadMyCustomer()

    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

.el-main {
  padding: 0;
}

.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}

.myform >>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-autocomplete {
  width: 100%;
}

.mycard >>> .el-card__body {
  padding: 20px 0;
}

.mycard >>> .el-tree-node__content {
  height: 30px;
}


</style>
